import React from "react";
import IQDaysBarGraph from "./IQDaysBarGraph";

export default function ScoreHistoryScreen({ game }) {
  const [showGraph, setShowGraph] = React.useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0f172a] via-[#18122b] to-[#09090b] text-white flex flex-col">
      <div className="sticky top-0 z-20 flex items-center justify-between px-3 py-2 border-b border-violet-500/30 bg-[#120d25]/90 backdrop-blur">
        <button
          onClick={() => game.setScreen("home")}
          className="w-fit px-2 py-1 text-[11px] lg:text-sm text-violet-300 hover:text-violet-200 transition"
        >
          ← Back
        </button>

        <div className="text-center">
          <h2 className="text-sm font-bold tracking-wide text-cyan-200">
            🧠 Best Score History
          </h2>
          <div className="flex items-center gap-2">
            <div className="text-[11px] lg:text-sm text-zinc-200">
              {game.streakHistory.length} Attempts
            </div>
            <button
              onClick={() => setShowGraph(!showGraph)}
              className={`w-fit px-2 py-1 rounded-full text-xs lg:text-sm font-semibold transition
                    ${
                      showGraph
                        ? "bg-cyan-500 text-black"
                        : "bg-cyan-500/20 text-cyan-300"
                    }`}
            >
              📊 Graph
            </button>
          </div>
        </div>
        <div className="w-10" />
      </div>

      {showGraph && (
        <div className="px-2 pt-2">
          <IQDaysBarGraph history={game.streakHistory} />
        </div>
      )}

      <div className="flex-1 overflow-y-auto p-2 space-y-2">
        {game.streakHistory.length === 0 ? (
          <div className="flex flex-col items-center justify-center mt-24">
            <div className="text-5xl">🪹</div>
            <div className="mt-3 text-xs text-zinc-400">No history yet.</div>
          </div>
        ) : (
          game.streakHistory.map((item, index) => {
            const dt = new Date(item.confirmedAt);

            return (
              <div
                key={item._id || index}
                className="rounded-2xl border border-violet-500/20 bg-[#1b1730]/90 p-2 shadow-lg hover:border-pink-400/40 transition-all"
              >
                <div className="flex items-center justify-between mb-2">
                  <span className="text-[11px] lg:text-sm text-zinc-400">
                    #{game.streakHistory.length - index}
                  </span>
                  <span className="text-[11px] lg:text-sm bg-violet-600/20 text-violet-300 rounded-full px-2 py-1">
                    {dt.toLocaleDateString("en-GB")} ·{" "}
                    {dt.toLocaleDateString("en-US", {
                      weekday: "short",
                    })}
                  </span>
                  <span className="text-[11px] lg:text-sm bg-cyan-500/20 text-cyan-300 rounded-full px-2 py-1">
                    {dt.toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </span>
                </div>

                <div className="flex flex-wrap gap-2">
                  <div className="bg-[#26203f] rounded-lg px-2 py-1 w-fit">
                    <div className="text-[11px] lg:text-sm text-zinc-400 uppercase">
                      Level
                    </div>
                    <div className="text-xs font-bold text-pink-300">
                      {item.currentLevel}
                    </div>
                  </div>
                  <div className="bg-[#26203f] rounded-lg px-2 py-1 w-fit">
                    <div className="text-[11px] lg:text-sm text-zinc-400 uppercase">
                      Set
                    </div>
                    <div className="text-xs font-bold text-yellow-300">
                      {item.currentSet}
                    </div>
                  </div>

                  <div className="bg-[#1b3327] rounded-lg px-2 py-1 w-fit">
                    <div className="text-[11px] lg:text-sm text-zinc-400 uppercase">
                      IQ
                    </div>
                    <div className="text-xs font-bold text-green-400">
                      {item.iqAtTime}
                    </div>
                  </div>

                  <div className="bg-[#312515] rounded-lg px-2 py-1 w-fit">
                    <div className="text-[11px] lg:text-sm text-zinc-400 uppercase">
                      Correct
                    </div>
                    <div className="text-xs font-bold text-orange-300">
                      {item.xp}
                    </div>
                  </div>

                  <div className="bg-[#13293d] rounded-lg px-2 py-1 w-fit">
                    <div className="text-[11px] lg:text-sm text-zinc-400 uppercase">
                      Time
                    </div>
                    <div className="text-xs font-bold text-cyan-300">
                      {(Number(item.timeTaken) / 1000).toFixed(2)}s
                    </div>
                  </div>
                </div>

                <div className="mt-2 flex justify-between items-center">
                  {index === 0 ? (
                    <span className="text-[11px] lg:text-sm px-2 py-1 rounded-full bg-emerald-500/20 text-emerald-300">
                      🚀 Latest
                    </span>
                  ) : (
                    <span className="v px-2 py-1 rounded-full bg-zinc-700/40 text-zinc-300">
                      History
                    </span>
                  )}
                  <span className="text-[11px] lg:text-sm text-violet-300">
                    🧠 {item.remarks || "Keep Going!"}
                  </span>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
